import Reveal from "@/components/landing/Reveal";

export default function Empathy() {
    return (
        <section
            id="approach"
            data-testid="empathy-section"
            className="relative bg-cacao text-pearl py-32 md:py-44 overflow-hidden"
        >
            <div className="grain" aria-hidden="true" />
            <div className="max-w-[1100px] mx-auto px-6 md:px-12 relative">
                <Reveal>
                    <p className="eyebrow text-pearl/60 mb-10" data-testid="empathy-eyebrow">
                        <span className="divider-line bg-pearl/40 mr-4 align-middle" />
                        {"The quiet problem"}
                    </p>
                </Reveal>

                <Reveal delay={120}>
                    <h2
                        data-testid="empathy-headline"
                        className="font-serif text-pearl text-[2.2rem] sm:text-[3rem] md:text-[4rem] leading-[1.05] max-w-[20ch]"
                    >
                        {"Your home is full of beautiful things."}
                        <span className="block text-pearl/65 italic mt-3">
                            {"So why doesn\u2019t it feel finished?"}
                        </span>
                    </h2>
                </Reveal>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-20 mt-16 md:mt-24">
                    <Reveal delay={200}>
                        <p className="text-pearl/85 text-[1.02rem] md:text-[1.08rem] leading-[1.85] font-light">
                            {"You\u2019ve collected pieces you love. You\u2019ve saved a hundred images of rooms that feel right. But somehow it hasn\u2019t come together — the rooms don\u2019t talk to each other, every decision feels like a risk, and you don\u2019t have the time to research, source and coordinate it all."}
                        </p>
                    </Reveal>
                    <Reveal delay={320}>
                        <p className="text-pearl/85 text-[1.02rem] md:text-[1.08rem] leading-[1.85] font-light">
                            {"It isn\u2019t your taste that\u2019s missing. It\u2019s a trained eye to bring it into focus — someone who can see what you can\u2019t, make the hard calls with you, and give you back a home that feels calm, cohesive and complete."}
                        </p>
                    </Reveal>
                </div>

                <Reveal delay={500}>
                    <p
                        data-testid="empathy-transition"
                        className="mt-20 md:mt-28 font-serif italic text-clay text-[1.4rem] md:text-[1.8rem]"
                    >
                        {"That\u2019s where Arc & Light begins."}
                    </p>
                </Reveal>
            </div>
        </section>
    );
}
